var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4941,
    cy: 12.2427,
    r: 9.375,
    transform: "rotate(-90 12.4941 12.2427)",
    fill: "#FCFEFF",
    stroke: "#1B1A1B",
    strokeWidth: 1.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_20206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2124 10.4121L12.3282 14.1414",
    stroke: "#1B1A1B",
    strokeWidth: 1.58629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4434 10.4121L12.3276 14.1414",
    stroke: "#1B1A1B",
    strokeWidth: 1.58629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_20206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.77778,
    height: 16,
    fill: "white",
    transform: "matrix(0 1 1 0 4.49414 7.23682)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowDown);
export default __webpack_public_path__ + "static/media/circle-arrow-down.5f22878bca28dd87ee8e05e6770d6631.svg";
export { ForwardRef as ReactComponent };